module.exports = __webpack_public_path__ + "img/lisaweb.6020e3a2.png";